export default "__VITE_ASSET__CuoqkLX0__"